import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { DayOfYear } from './day-of-year.js';

export class BirthDate extends DataModel {
  static readonly TYPE_ID: string = '12bec83cb97b468cb54494e514757527';

  constructor(
    public readonly year: number, // make optional in a future release
    public readonly month: number,
    public readonly day: number,
  ) {
    super();
  }

  get $typeId(): string {
    return BirthDate.TYPE_ID;
  }

  static fromDayOfYear(dayOfYear: DayOfYear): BirthDate {
    return new BirthDate(
        dayOfYear.year,
        dayOfYear.month,
        dayOfYear.day,
    );
  }

  static fromDate(date: dayjs.Dayjs): BirthDate {
    return new BirthDate(
        date.year(),
        date.month() + 1, // In dayjs months start at 0 not 1. The app expects month to start at 1.
        date.date(),
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): BirthDate {
    return new BirthDate(
        MapUtils.get<number>(map, 'year'),
        MapUtils.get<number>(map, 'month'),
        MapUtils.get<number>(map, 'day'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'year': this.year,
      'month': this.month,
      'day': this.day,
    };
  }

  clone(): this {
    return new BirthDate(
        this.year,
        this.month,
        this.day,
    ) as this;
  }

  isSame(other: BirthDate): boolean {
    if(this === other) {
      return true;
    }

    return other.year === this.year && other.month === this.month && other.day === this.day;
  }

  toDayOfYear(): DayOfYear {
    return new DayOfYear(this.year, this.month, this.day);
  }
}

export class BirthDateBuilder extends DataModelBuilder<BirthDate> {
  build(context: SerializationContext, map: SerializedData): BirthDate {
    return BirthDate.fromMap(context, map);
  }
}
